@if (open) {
  <div
    class="alert-dialog-overlay"
    [style.z-index]="overlayZIndex"
    (click)="onClose.emit()"
    (keydown.enter)="onClose.emit()"
    (keydown.escape)="onClose.emit()"
    tabindex="0"
    role="dialog"
  >
    <div
      class="alert-dialog-container"
      [attr.data-type]="type"
      [attr.data-variant]="variant"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
      tabindex="0"
      role="dialog"
    >
      <div class="alert-dialog-content">
        <h3 class="alert-dialog-title">{{ title }}</h3>
        <div class="alert-dialog-message">{{ message }}</div>

        <ng-content></ng-content>

        <div class="alert-dialog-buttons">
          <umss-button
            [label]="primaryButtonLabel"
            [variant]="primaryButtonVariant"
            [size]="'Regular'"
            [loading]="loading"
            [leftIconName]="primaryButtonLeftIconName"
            [rightIconName]="primaryButtonRightIconName"
            (onClick)="handlePrimaryClick()"
          />

          <umss-button
            *ngIf="showSecondaryButton"
            [label]="secondaryButtonLabel"
            [variant]="secondaryButtonVariant"
            [size]="'Regular'"
            [loading]="loading"
            [leftIconName]="secondaryButtonLeftIconName"
            [rightIconName]="secondaryButtonRightIconName"
            (onClick)="handleSecondaryClick()"
          />
        </div>
      </div>
    </div>
  </div>
}
